import firebase from "@firebase/app";
import schema from './schema'
import Vue from "vue"
import moment from '@/moment-gp'
import { get_ready } from '@/api/misc' // only import get_ready to avoid circular dependency

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {

    get_user_settings: ( $models, $registry ) => {
      if ( get_ready('user') ) { // auth?
        let userId = $models.user.defaultUserId
        return $registry.state.res.user[ userId ].settings.settings;
      }
      return null
    },

    example: ( $models, $registry, $store ) => {
      // $store.get_user_settings
    },

    get_profile_pic: ($models, $registry, $store) => {
      /* TODO: analoge version für contact */
      /* TODO: return loading */
      /* TODO: return default from local / no svg */

      let userAuth = firebase.auth().currentUser;
      // $models.user.defaultUserId
      let userData = $models.userPublic.getNode( userAuth.uid )
      // let userAuth = $vuexstore.getters["user/userAuth"];

      if ( 'profilePic' in userData && userData.profilePic !== "" ) {
        return userData.profilePic;
      } else if ( 'picture' in userAuth && userAuth.picture !== "" &&
          userAuth.picture !== null ) {
        return userAuth.picture;
      } else {
        let filter = Vue.filter("defaultUserPic");
        return filter(null);
      }
    },

    user_get_language: ($models, $registry, $store) => {
      let settings = $store.getters.get_user_settings;
      if (settings &&
          settings.language &&
          settings.language !== "" ) {
        // TODO: check if language valid
        return settings.language;
      }
      return null;
    },

    user_get_timezone: ($models, $registry, $store) => {
      let settings = $store.getters.get_user_settings;
      if (settings &&
          settings.timezone &&
          settings.timezone !== "" &&
          moment.tz.zone(settings.timezone)) { // check if timezone valid
        return settings.timezone;
      }
      // no valid timezone found, return nothing
      return 'I/DONT/KNOW' // TODO: null
    },

    user_get_dateformat: ($models, $registry, $store) => {
      let settings = $store.getters.get_user_settings;
      if (settings &&
          settings.dateformat &&
          settings.dateformat !== "" ) {
        return settings.dateformat;
      }
      return 'LLLL';
    },
  },
  staticActions: {},
  schema:  schema
};
